import * as Ariakit from '@ariakit/react'

interface PopoverProviderProps extends Omit<Ariakit.PopoverProviderProps, 'store'> {
  state?: Ariakit.PopoverProviderProps['store']
}

export function PopoverProvider({ state, ...props }: PopoverProviderProps) {
  return <Ariakit.PopoverProvider store={state} placement="bottom-start" {...props} />
}
